var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.8 192.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.8v192.8H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 94v2.3c0 32.8 26.6 59.5 59.4 59.5 27.3 0 50.2-18.3 57.2-43.3l-95.3 1.1 23-17.7L37 94zm2.2-13.6c7-25.2 29.9-43.5 57.2-43.5 32.8 0 59.4 26.6 59.4 59.4v2.9l-44.2-2 23.6-18-96 1.2zm-9.9 13.2l-20.8-.8V80.7l22.6-.2c7.2-29.3 33.7-51.2 65.3-51.2 37 0 67.1 30.1 67.1 67.1 0 1.1 0 2.1-.1 3.2l20.9.9v12l-22.6.2c-7.3 29.2-33.7 51-65.3 51-37.2 0-67.2-30.1-67.2-67.2 0-1 0-1.9.1-2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpel);
export default __webpack_public_path__ + "static/media/opel.4eb0e192d606cf5d88c38793cbeafc33.svg";
export { ForwardRef as ReactComponent };